(function () {
    "use strict";

    angular
        .module("app")
        .directive("constructionSearchHelp", ["SearchFactory", constructionSearchHelp]);

    function constructionSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.constructionKey = "";
                        scope.constructionDesc = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.ConstructionDesc === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.constructionSearch(function (construction) {
                        scope.constructionKey = construction ? construction.ConstructionKey : "";
                        scope.constructionDesc = construction ? construction.ConstructionDesc : "";
                        scope.displayValue = scope.ConstructionDesc;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.ConstructionDesc;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("constructionDesc", function (newValue) {
                    scope.displayValue = newValue;
                });
                
            },
            scope: { constructionKey: "=", constructionDesc: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

